import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  GET_MASTER_PAYMENT_PROVIDER_LIST,
  GET_MASTER_PAYMENT_PROVIDER_DATA,
  CREATE_MASTER_PAYMENT_PROVIDER,
  UPDATE_MASTER_PAYMENT_PROVIDER,
  DELETE_MASTER_PAYMENT_PROVIDER,
} from "./actionType";

import {
  getMasterPaymentProviderListSuccess,
  getMasterPaymentProviderListFail,
  getMasterPaymentProviderDataSuccess,
  getMasterPaymentProviderDataFail,
  createMasterPaymentProviderSuccess,
  createMasterPaymentProviderFail,
  updateMasterPaymentProviderSuccess,
  updateMasterPaymentProviderFail,
  deleteMasterPaymentProviderSuccess,
  deleteMasterPaymentProviderFail,
} from "./action";

import {
  getMasterPaymentProviderListApi,
  getMasterPaymentProviderDataApi,
  createMasterPaymentProviderApi,
  updateMasterPaymentProviderApi,
  deleteMasterPaymentProviderApi,
} from "../../helpers/fakebackend_helper";

// Get masterPaymentProvider list
function* getMasterPaymentProviderList() {
  try {
    const response = yield call(getMasterPaymentProviderListApi);
    yield put(getMasterPaymentProviderListSuccess(response));
  } catch (error) {
    yield put(getMasterPaymentProviderListFail(error));
  }
}
function* watchGetMasterPaymentProviderList() {
  yield takeEvery(
    GET_MASTER_PAYMENT_PROVIDER_LIST,
    getMasterPaymentProviderList
  );
}

// Get masterPaymentProvider data
function* getMasterPaymentProviderData(action) {
  try {
    const response = yield call(
      getMasterPaymentProviderDataApi,
      action.payload
    );
    yield put(getMasterPaymentProviderDataSuccess(response));
  } catch (error) {
    yield put(getMasterPaymentProviderDataFail(error));
  }
}
function* watchGetMasterPaymentProviderData() {
  yield takeEvery(
    GET_MASTER_PAYMENT_PROVIDER_DATA,
    getMasterPaymentProviderData
  );
}

// Create masterPaymentProvider
function* createMasterPaymentProvider(action) {
  try {
    const response = yield call(createMasterPaymentProviderApi, action.payload);
    yield put(createMasterPaymentProviderSuccess(response));
  } catch (error) {
    yield put(createMasterPaymentProviderFail(error));
  }
}
function* watchCreateMasterPaymentProvider() {
  yield takeEvery(CREATE_MASTER_PAYMENT_PROVIDER, createMasterPaymentProvider);
}

// Update masterPaymentProvider
function* updateMasterPaymentProvider(action) {
  try {
    const response = yield call(updateMasterPaymentProviderApi, action.payload);
    yield put(updateMasterPaymentProviderSuccess(response));
  } catch (error) {
    yield put(updateMasterPaymentProviderFail(error));
  }
}
function* watchUpdateMasterPaymentProvider() {
  yield takeEvery(UPDATE_MASTER_PAYMENT_PROVIDER, updateMasterPaymentProvider);
}

// Delete masterPaymentProvider
function* deleteMasterPaymentProvider(action) {
  try {
    const response = yield call(deleteMasterPaymentProviderApi, action.payload);
    yield put(deleteMasterPaymentProviderSuccess(response));
  } catch (error) {
    yield put(deleteMasterPaymentProviderFail(error));
  }
}
function* watchDeleteMasterPaymentProvider() {
  yield takeEvery(DELETE_MASTER_PAYMENT_PROVIDER, deleteMasterPaymentProvider);
}

export default function* MasterPaymentProvider() {
  yield all([
    watchGetMasterPaymentProviderList(),
    watchGetMasterPaymentProviderData(),
    watchCreateMasterPaymentProvider(),
    watchUpdateMasterPaymentProvider(),
    watchDeleteMasterPaymentProvider(),
  ]);
}
